// Next
import { useTranslation } from 'react-i18next'

// Mui
import Box from '@mui/material/Box'

// Sections
import OurServicesSection from './sections/OurSolutionsSection'

// Styles
import themeColors from '@/assets/theme/colors'
import GetStartedSection from '@/components/getStarted/GetStartedSection'

export default function SolutionsView() {
  const { t } = useTranslation('solutions')

  return (
    <Box
      sx={{
        background: themeColors.kroemtech.background,
        paddingTop: '6rem'
      }}
    >
      <OurServicesSection />

      <GetStartedSection
        title={t('cta.title')}
        subTitle={t('cta.description')}
        button={t('cta.button')}
      />
    </Box>
  )
}
